class ProductViewed extends HTMLElement {
  handle = this.getAttribute('handle') || '';
  viewedProducts = JSON.parse(localStorage.getItem('viewedProducts') || '[]');

  connectedCallback() {
    if (!this.handle.length) return;
    // Check if the product already exists
    if (!this.viewedProducts.some((viewedHandle) => viewedHandle === this.handle)) {
      this.viewedProducts.unshift(this.handle); // Add to the beginning
    }
    // Limit to 8 products
    this.viewedProducts.length > 8 ? this.viewedProducts.pop() : null;
    // Set in storage
    localStorage.setItem('viewedProducts', JSON.stringify(this.viewedProducts));
  }
}

customElements.define('product-viewed', ProductViewed);
